<script setup>
const props = defineProps({
  data: { type: Object, required: true },
})
const card = props.data;


</script>

<template>
  <div class="style-card card">
    <div class="copy">
      <h1 v-if=card.title>{{ card.title }}</h1>
      <p v-if=card.style>{{ card.style }}</p>
    </div>
    <DImage v-if="card.image" :src="card.image.billboard.src" :alt="card.title"></DImage>
  
  </div>
</template>

<style scoped lang="scss">
.style-card {
  position: relative;
  
  width: 200px;
  height: 300px;
  
  .copy {
    position: absolute;
    width: 100%;
    height: auto;
    padding: 2rem;
    bottom: 0;
    text-align: left;
    
    h1 {
      text-align: left;
      font-size: 2rem;
    }
    p {
      font-size: 1.3rem;
      color: var(--color2);
    }
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 1rem;
    overflow: hidden;
  }
}

</style>
